package com.essntl.core.waypoint.domain.models

data class WaypointLogs(
    val id: String,
    val status: Status?,
    val message: String,
    val createdAt: String,
) {
    enum class Status {
        CREATED,
        SENT,
        DELIVERED,
        OPENED,
        ERROR;
    }
}
